<div class="container">
  <div class="title">
    {{
      'Ouvrir ' +
        (hospitalNames.vacationsNameGenreMasculin ? 'un ' : 'une ') +
        hospitalNames.vacationsName.toLowerCase()
    }}
  </div>

  <div class="h-580">
    <div>
      <div class="levels-header">
        <app-toggle
          *ngIf="!loadingInit && vacationModesOptions.length > 1"
          (onOptionClick)="toggleClick($event)"
          [actifOption]="actifVacationModeOption"
          [equalColumnsWidth]="true"
          [options]="vacationModesOptions"
          [showBorderBottom]="true"
          class="toggle"
        ></app-toggle>
      </div>
    </div>

    <div
      *ngIf="loadingProfiles"
      [ngStyle]="{ width: conditionalWidth }"
      style="display: flex; justify-content: center; align-items: center"
    >
      <mat-spinner diameter="60"></mat-spinner>
    </div>

    <form *ngIf="!loadingProfiles && formGroup" class="formContainer" fxLayout="column" fxLayoutAlign="start stretch">
      <div class="columns">
        <div class="column">
          <div class="row-select-container" fxLayout="row wrap" fxLayoutAlign="start start">
            <!-- date -->
            <div style="width: 144px">
              <app-date-input
                (dateChanged)="onDateChange()"
                [formCtrl]="formGroup!.get('day')! | formControl"
                [minDate]="today"
                label="Date"
                style="overflow: unset"
              ></app-date-input>
            </div>

            <!-- effectif -->
            <div class="width-80 default-select">
              <div class="select-label">Effectif</div>
              <div class="select-container" style="width: 72px">
                <select [formControl]="formGroup!.get('needs')! | formControl" required>
                  <option *ngFor="let need of needs" [value]="need">
                    {{ need }}
                  </option>
                </select>
              </div>
            </div>

            <!-- service -->
            <div *ngIf="isMultiHospitals" class="default-select">
              <div class="select-label">Service</div>
              <div class="select-container select-container-service">
                <select
                  (ngModelChange)="onChangeService()"
                  [formControl]="formGroup!.get('hospitals')! | formControl"
                  required
                  style="
                    padding: 0 32px 0 8px !important;
                    -webkit-padding-end: 32px !important;
                    -webkit-padding-start: 8px !important;
                  "
                >
                  <option *ngFor="let hospital of hospitals" [ngValue]="hospital">
                    {{ hospital.displayName }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <!-- position -->
          <div *ngIf="!isNurses; else ifNurses" class="default-select" style="width: 200px; margin-top: 16px">
            <div class="select-label">Poste</div>
            <div class="select-container">
              <select [formControl]="formGroup!.get('position')! | formControl" required>
                <option *ngFor="let position of nursesPosition" [value]="position">
                  {{ position }}
                </option>
              </select>
            </div>
          </div>
          <ng-template #ifNurses>
            <div *ngIf="nursesPosition && nursesPosition.length > 0" style="margin-top: 16px">
              <app-checkbox-group
                [disabled]="!!vacation"
                [elements]="nursesPosition"
                [formCtrl]="formGroup!.get('position')! | formControl"
                label="Poste"
                layout="row wrap"
              ></app-checkbox-group>
            </div>
          </ng-template>

          <div fxLayout="row" style="margin-top: 16px; justify-content: space-between">
            <!-- status -->
            <app-checkbox-group
              [disabled]="!!vacation"
              [elements]="residencies"
              [formCtrl]="formGroup!.get('residency')! | formControl"
              label="Statut"
              layout="row wrap"
            ></app-checkbox-group>

            <!-- seniority -->
            <div *ngIf="isAnesthesistePage() && showSeniority">
              <app-checkbox-group
                [disabled]="!!vacation"
                [elements]="seniorities"
                [formCtrl]="formGroup!.get('seniority')! | formControl"
                label="Séniorité"
                layout="row wrap"
              >
              </app-checkbox-group>
            </div>
          </div>

          <div fxLayout="row" style="margin-top: 16px">
            <!-- availability -->
            <ng-container *ngIf="!vacation && formGroup?.get('availability')">
              <app-radio-button-group
                layout="row"
                [label]="'Type de ' + hospitalNames.vacationsName.toLowerCase()"
                [formCtrl]="formGroup!.get('availability')! | formControl"
                [elements]="availabilities"
              ></app-radio-button-group>
            </ng-container>
          </div>

          <!-- time code -->
          <div class="default-select" style="width: 280px; margin-top: 16px">
            <div class="select-label">Code Horaire</div>
            <div class="select-container inputs-width">
              <select
                (focus)="onSelectOpen()"
                (ngModelChange)="changePreselectedReasonMap($event)"
                [(ngModel)]="selectedReasonMap"
                [disabled]="isTimeCodeDisabled"
                [matTooltip]="isTimeCodeDisabled ? 'Veuillez sélectionner un poste et un statut.' : ''"
                [ngModelOptions]="{ standalone: true }"
              >
                @if (!isBasicService) {
                  <option [ngValue]="null">--------</option>
                }

                <option *ngFor="let reasonMap of filteredReasonsMaps" [ngValue]="reasonMap">
                  {{
                    (reasonMap.code === 'SMARTOP_DAY_ASTREINTE' || reasonMap.code === 'SMARTOP_NIGHT_ASTREINTE'
                      ? 'Astreinte'
                      : reasonMap.code) +
                      ' (' +
                      (reasonMap.nightStartTime !== null && reasonMap.nightStartTime !== undefined
                        ? shortenHours(reasonMap.nightStartTime) +
                          ' - ' +
                          shortenHours(reasonMap.nightEndTime) +
                          ' ' +
                          (typeof reasonMap.reason === 'object' && $any(reasonMap?.reason).title !== undefined
                            ? $any(reasonMap.reason).title
                            : '')
                        : shortenHours(reasonMap.morningStartTime) + ' - ' + shortenHours(reasonMap.afternoonEndTime)) +
                      ')' +
                      (reasonMap.recommended ? ' - Recommandé' : '')
                  }}
                </option>
              </select>
            </div>
          </div>

          <div *ngIf="availability === 'AVAILABLE'" style="margin-top: 16px">
            <div fxLayout="row" fxLayoutAlign="start start" style="gap: 4px">
              <app-hours-input
                #startTime
                (timeChanged)="setStartTime($event)"
                [defaultTime]="getStartTime()"
                [format]="24"
                class="margin-bottom"
                label="Début de disponibilité"
              ></app-hours-input>
              <app-hours-input
                #endTime
                (timeChanged)="setEndTime($event)"
                [defaultTime]="getEndTime()"
                [format]="24"
                label="Fin de disponibilité"
              ></app-hours-input>
            </div>
          </div>

          <!-- motifs -->
          <div *ngIf="availability === 'AVAILABLE'" class="default-select" style="width: 280px; margin-top: 16px">
            <div class="select-label">Motif d'ouverture</div>
            <div class="select-container inputs-width">
              <select
                (ngModelChange)="onChangeSelectedMotif($event)"
                [(ngModel)]="selectedMotif"
                [disabled]="isTimeCodeDisabled"
                [matTooltip]="isTimeCodeDisabled ? 'Veuillez sélectionner un poste et un statut.' : ''"
                [ngModelOptions]="{ standalone: true }"
              >
                <option [ngValue]="null">--------</option>
                <option *ngFor="let motif of motifs" [ngValue]="motif">
                  {{ motif.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div *ngIf="actifVacationMode === 'targetVacation' && competenceFilter" class="column" style="width: 464px">
          <div>
            <div>
              @if (!isBasicService) {
                <!-- competence -->
                @if (availability === 'AVAILABLE') {
                  <div class="width-150 default-select">
                    <div class="select-label">
                      {{
                        !data.specialties || chosenSpecialties.length <= 1
                          ? hospitalNames.specialtiesName + ' :'
                          : hospitalNames.specialtiesName + 's :'
                      }}
                    </div>
                    @if (chosenSpecialties.length <= 1) {
                      <div class="select-container">
                        <select
                          [formControl]="formGroup!.get('competence')! | formControl"
                          [matTooltip]="vacation && 'Présélectionnée selon vos besoins'"
                          required
                        >
                          <option value="undefined">
                            {{ hospitalNames.specialtiesNameGenreMasculin ? 'Tous les ' : 'Toutes les '
                            }}{{ hospitalNames.specialtiesName.toLowerCase() + 's' }}
                          </option>
                          @for (specialty of isNurses ? specialties : anesthSpecialties; track specialty._id) {
                            <option [value]="specialty._id">
                              {{ specialty.name }}
                            </option>
                          }
                        </select>
                      </div>
                    }
                    @if (chosenSpecialties.length > 1) {
                      <div class="default-mat-select">
                        <mat-select
                          [formControl]="formGroup!.get('competences')! | formControl"
                          [matTooltip]="vacation && `Présélectionnées selon vos besoins`"
                          multiple
                          panelClass="mat-mdc-select-panel disabled-color"
                          placeholder="Spécialités"
                          required
                        >
                          @for (specialty of isNurses ? specialties : anesthSpecialties; track specialty._id) {
                            <mat-option [value]="specialty._id">
                              {{ specialty.name }}
                            </mat-option>
                          }
                        </mat-select>
                      </div>
                    }
                  </div>
                }
                <br />
                <!-- Aide Op || Circulante -->
                @if (showRole && availability === 'AVAILABLE') {
                  <div class="width-150 default-select">
                    @if (isNurses) {
                      <div>
                        <div class="select-label">Rôle :</div>
                        <div class="select-container">
                          <select
                            [formControl]="formGroup!.get('typeInf')! | formControl"
                            [matTooltip]="vacation && 'Présélectionné selon vos besoins'"
                          >
                            <!-- change option-->
                            @for (type of typeInfOptions; track type.value) {
                              <option [value]="type.value">
                                {{ type.label }}
                              </option>
                            }
                            @if (typeInfOptions.length === 0) {
                              <option value="undefined">
                                Aucun rôle pour {{ hospitalNames.specialtiesNameGenreMasculin ? 'ce ' : 'cette '
                                }}{{ hospitalNames.specialtiesName.toLowerCase() }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                    } @else {
                      @if (!chosenPositions || (formationsGroupOfPosition?.workScopes?.length ?? 0) > 0) {
                        <div class="select-label">Type :</div>
                      }
                      @if (!chosenPositions || (formationsGroupOfPosition?.workScopes?.length ?? 0) > 0) {
                        <div class="select-container">
                          <select [formControl]="formGroup!.get('typeAnesth')! | formControl">
                            @for (type of typeAnesthOptions; track type.value) {
                              <option [value]="type.value">
                                {{ type.label }}
                              </option>
                            }
                          </select>
                        </div>
                      }
                    }
                  </div>
                }
              }
            </div>

            <!-- Competences filter - FIN -->
            <div>
              <div *ngIf="!loadingProfiles && data.profile" class="profile-vacation-container">
                <app-smart-op-avatar [profile]="data.profile"></app-smart-op-avatar>
              </div>
              <!-- show profiles based on 2nd route when competense filter is checked -->
              <div *ngIf="!loadingProfiles && !data.profile" class="width-150 default-select">
                <div *ngIf="availability === 'ABSENT'">
                  <mat-slide-toggle [formControl]="formGroup!.get('selectOutOfRoomProfiles')! | formControl"
                    >Afficher seulement les collaborateurs hors salle
                  </mat-slide-toggle>
                </div>
                <br />
                <div class="profiles-label-container">
                  <div class="select-label role-filter profiles-label">Collaborateurs sollicitables :</div>
                  <div class="select-all-checkbox">
                    <mat-slide-toggle [formControl]="formGroup!.get('selectAllProfiles')! | formControl"
                      >Sélectionner tous
                    </mat-slide-toggle>
                  </div>
                </div>
                <br />
                <div
                  *ngIf="resultProfiles2.length > 0; else noProfile"
                  class="profiles-box"
                  [style.max-height]="availability === 'ABSENT' ? '535px' : '400px'"
                >
                  <div *ngFor="let profile of resultProfiles2; let i = index" class="profile-box">
                    <mat-checkbox
                      (change)="changeSelectAllState()"
                      [(ngModel)]="profile.checked"
                      [disabled]="!profile.haveUser"
                      [ngClass]="{ 'text-gray': !profile.haveUser }"
                      [ngModelOptions]="{ standalone: true }"
                    >
                      <span *ngIf="chosenSpecialty !== 'undefined'">{{ i + 1 }} - </span
                      >{{ toPascalCase(profile.firstName ?? '') }} {{ toPascalCase(profile.lastName ?? '')
                      }}{{
                        !isNurses && showSeniority && chosenSeniorities.length > 1
                          ? ' - ' + (profile.seniority | formatSeniority)
                          : ''
                      }}
                      {{
                        availability === 'AVAILABLE'
                          ? profile.calendar && profile.calendar.length > 0
                            ? profile.calendar[0].reason[0].title !== 'Autre'
                              ? ' (abs - ' + profile.calendar[0].reason[0].title + ')'
                              : ' (abs - ' + profile.calendar[0].customDescription + ')' || ' (abs - non renseignée)'
                            : ' (abs - non renseignée)'
                          : profile.isOutOfRoom
                            ? ' (hors-salle)'
                            : ' (en salle)'
                      }}
                    </mat-checkbox>
                  </div>
                </div>
                <ng-template #noProfile>
                  <p style="width: 440px">Aucun profil trouvé</p>
                </ng-template>
                <div *ngIf="resultProfiles2.length > 0" class="legend">
                  <p style="margin: 4px; margin-left: 8px; font-size: 13px">
                    Légende :
                    <span>
                      <mat-checkbox [disabled]="true" [ngClass]="'text-gray'">
                        Collaborateur sans compte</mat-checkbox
                      ></span
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="!loadingProfiles && formGroup" class="buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-button (click)="close()" btnType="text" text="Annuler"></app-button>
    <app-button
      (click)="save()"
      [disabled]="!haveSeniority || !formGroup!.valid || isDisabled || (competenceFilter && !isAnyProfileChecked)"
      [isSpinner]="true"
      [isSpinning]="isSpinning"
      text="Valider l'ouverture"
    ></app-button>
  </div>
</div>
